import type { AddAccount } from "@/models/account";
import type { AccountConsentRequest } from "@/models/accountConsentRequest";

export const validateBBAN = async (
  bban: string,
  externalId: string
): Promise<{
  bban: string;
  errorMessage: string;
  iban: string;
  isValid: boolean;
}> => {
  const url = `/api/onboarding/account/validate-bban`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ bban, externalId }),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`validateBBAN: ${error}`);
    throw error;
  }
};

export const addBankAccount = async (
  addAccount: AddAccount
): Promise<any> => {
  const url = `/api/onboarding/account/add`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addAccount),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`AddBankAccount: ${error}`);
    throw error;
  }
};

export const requestBankAccountConsent = async (
  accountConsentRequest: AccountConsentRequest
): Promise<any> => {
  const url = `/api/onboarding/account/request`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountConsentRequest),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`requestBankAccountConsent: ${error}`);
    throw error;
  }
};

export const postScaComplete = async (id: string, code: string): Promise<any> => {
  const url = `/api/onboarding/account/request/${id}/sca-complete`;
  try {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code }),
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`postScaComplete exception: ${error}`);
    throw error;
  }
}

export const getAccountRequest = async (id: string): Promise<any> => {
  const url = `/api/onboarding/account/request/${id}`;
  try {
    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`getPayment exception: ${error}`);
    throw error;
  }
};

// /onboarding/account/request/{id}/init-payment
export const initPaymentFromAccountRequest = async (id: string): Promise<any> => {
  const url = `/api/onboarding/account/request/${id}/init-payment`;
  try {
    const resp = await fetch(url, {
      method: "POST",
    });
    if (!resp.ok) {
      throw new Error(`Network response was not ok: ${resp.status}`);
    }
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error(`initPaymentFromAccountRequest exception: ${error}`);
    throw error;
  }
};
